export const INVALIDATE_APPLICATION_CACHE_IF_NEEDED =
  'INVALIDATE_APPLICATION_CACHE_IF_NEEDED';
export const UPDATE_CURRENT_APPLICATION_VERSION =
  'UPDATE_CURRENT_APPLICATION_VERSION';
export const UPDATE_TIMESTAMP_OF_LATEST_BUILD =
  'UPDATE_TIMESTAMP_OF_LATEST_BUILD';
